<span
  class="sale"
  [style.height.rem]="size"
  [style.width.rem]="size"
  [style.line-height.rem]="size"
  [style.font-size.rem]="size * 0.6"
>
  <span class="content">%</span>
</span>
